/* global FileReader */
const fileToBase64 = file =>
  new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = () => resolve(reader.result.split(',').pop())
    reader.onerror = reject
    reader.readAsDataURL(file)
  })

export default fileToBase64
